// extracted by mini-css-extract-plugin
export default {"landingPageOptionList":"LandingPageOptionList_landingPageOptionList__LX+F5"};